import React from "react";
import { Col, ControlLabel, FormControl, Grid, Row } from "react-bootstrap";

const NameEditPage = ({ disabled, value, onChange }) => {
  return (
    <Grid fluid>
      <Row>
        <Col xs={12} md={8} mdOffset={2}>
          <ControlLabel htmlFor={"audio-block-name"}>Name</ControlLabel>
          <FormControl
            disabled={disabled}
            type={"text"}
            id={"audio-block-name"}
            value={value}
            onChange={onChange}
          />
        </Col>
      </Row>
    </Grid>
  );
};

export default NameEditPage;
